import { useAuthQuery } from '@/hooks/use-auth-query'
import fetch from '@/api/fetch-with-authorization'
import { END_POINTS } from '@/api/end-points'

/**
 * Hook to fetch active promo code for the authenticated user
 * Results are cached for 1 hour (staleTime) and kept in cache for 12 hours (cacheTime)
 * @returns {Object} Object containing activePromoCode, isLoading, and error
 */
export const useActivePromoCode = () => {
  const { data, isLoading, error } = useAuthQuery({
    queryKey: ['active-promo-code'],
    queryFn: async () => {
      const response = await fetch({ path: END_POINTS.GET_ACTIVE_PROMO_CODE })
      return response
    },
    staleTime: 60 * 60 * 1000, // 1 hour - data is fresh for 1 hour
    cacheTime: 12 * 60 * 60 * 1000, // 12 hours - keep in cache for 12 hours
    refetchOnWindowFocus: false, // Don't refetch on window focus since promo codes don't change frequently
  })

  return {
    activePromoCode: data?.activePromoCode || null,
    isLoading,
    error,
  }
}
